// removed by extract-text-webpack-plugin
module.exports = {"root":"ProfileIcon__root--3kRUa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/ProfileIcon/ProfileIcon.css
// module id = ./src/components/Library/ProfileIcon/ProfileIcon.css
// module chunks = 1